module.exports = __webpack_public_path__ + "media/images/weather/99_day-03b529f911954529cd86b63010ecf3f0.png";